import React from 'react';

export default function PostizEmbed() {
  return (
    <div className="h-[calc(100vh-80px)] w-full">
      <iframe
        src="https://postiz.minhainbase.com.br"
        className="w-full h-full border-0 rounded-xl shadow"
        title="Postiz"
        allow="camera; microphone; clipboard-write"
      />
    </div>
  );
}
